export const WebFormType = {
  SPECIAL_GIVEAWAY: "SPECIAL_GIVEAWAY",
  PA_KOOMSURE_SPECIAL_GIVEAWAY: "PA_KOOMSURE_SPECIAL_GIVEAWAY",
};

export const CoveragePlan = {
  GOLD: "Gold",
};
